import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PostItemDetailComponent } from './pages/post-item-detail/post-item-detail.component';
import { CommunityLayoutComponent } from './layout/community-layout/community-layout.component';
import { TrendingPostsComponent } from './pages/trending-posts/trending-posts.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: "community",
    component: CommunityLayoutComponent,
    canActivate: [MsalGuard],
    data: { redirectTo: ["community"] }
  },
  {
    path: "community/post/detail/:id",
    component: PostItemDetailComponent,
    canActivate: [MsalGuard],
    data: { redirectTo: ["community/post/detail/:id"] }
  },
  {
    path: "trending-post/:groupId",
    component: TrendingPostsComponent,
    canActivate: [MsalGuard],
    data: { redirectTo: ["trending-post/:groupId"] }
  }

];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CommunityRoutingModule { }
